import { parse, output } from './parser/nob5'

const nserial2 = '090123456789'
const nserial3 = '0890123456789789 019'
const nserial4 = '07890123456789'
const logarithm = ['05', '16', '27', '38', '49', '50', '61', '72', '83', '94']
const removeOptions = ['去重', '去双双重', '去三重', '去四重', '去二兄', '去三兄', '去四兄']
const sumOptions = ['取二合', '取三合']
const fanTong = {1: '一', 2: '二', 3: '三', 4: '四'}
const fanChe = {1: '124', 2: '123', 3: '234', 4: '134'}

const betNumbers = {
  '全': '0123456789',
  '单': '13579',
  '双': '02468',
  '小': '01234',
  '大': '56789',
}

const betMethodOne1 = 'OXXXX'
const betMethodOne2 = 'XOXXX'
const betMethodOne3 = 'XXOXX'
const betMethodOne4 = 'XXXOX'
const betMethodOne5 = 'XXXXO'
const betMethodsOne = [
  betMethodOne1, betMethodOne2, betMethodOne3, betMethodOne4, betMethodOne5
]
const betMethodsOneInChinese = {
  '万': betMethodOne1,
  '千': betMethodOne2,
  '百': betMethodOne3,
  '十': betMethodOne4,
  '个': betMethodOne5,
  '1位': betMethodOne1,
  '2位': betMethodOne2,
  '3位': betMethodOne3,
  '4位': betMethodOne4,
  '5位': betMethodOne5,
  '前': betMethodOne1,
  '中': betMethodOne3,
  '后': betMethodOne5,
}
export const betMethodsOneToCommand = {
  [betMethodOne1]: '万',
  [betMethodOne2]: '千',
  [betMethodOne3]: '百',
  [betMethodOne4]: '十',
  [betMethodOne5]: '个',
}

const betMethodTwo12 = 'OOXXX'
const betMethodTwo13 = 'OXOXX'
const betMethodTwo14 = 'OXXOX'
const betMethodTwo15 = 'OXXXO'
const betMethodTwo23 = 'XOOXX'
const betMethodTwo24 = 'XOXOX'
const betMethodTwo25 = 'XOXXO'
const betMethodTwo34 = 'XXOOX'
const betMethodTwo35 = 'XXOXO'
const betMethodTwo45 = 'XXXOO'
const betMethodsTwo = [
  betMethodTwo12, betMethodTwo13, betMethodTwo14, betMethodTwo15, betMethodTwo23,
  betMethodTwo24, betMethodTwo25, betMethodTwo34, betMethodTwo35, betMethodTwo45
]
const betMethodsTwoInChinese = {
  '万千': betMethodTwo12,
  '万百': betMethodTwo13,
  '万十': betMethodTwo14,
  '万个': betMethodTwo15,
  '千百': betMethodTwo23,
  '千十': betMethodTwo24,
  '千个': betMethodTwo25,
  '百十': betMethodTwo34,
  '百个': betMethodTwo35,
  '十个': betMethodTwo45,
  '12位': betMethodTwo12,
  '13位': betMethodTwo13,
  '14位': betMethodTwo14,
  '15位': betMethodTwo15,
  '23位': betMethodTwo23,
  '24位': betMethodTwo24,
  '25位': betMethodTwo25,
  '34位': betMethodTwo34,
  '35位': betMethodTwo35,
  '45位': betMethodTwo45,
  '前二': betMethodTwo12,
  '后二': betMethodTwo45,
}
export const betMethodsTwoToCommand = {
  [betMethodTwo12]: '万千',
  [betMethodTwo13]: '万百',
  [betMethodTwo14]: '万十',
  [betMethodTwo15]: '万个',
  [betMethodTwo23]: '千百',
  [betMethodTwo24]: '千十',
  [betMethodTwo25]: '千个',
  [betMethodTwo34]: '百十',
  [betMethodTwo35]: '百个',
  [betMethodTwo45]: '十个',
}

const betMethodThree123 = 'OOOXX'
const betMethodThree124 = 'OOXOX'
const betMethodThree125 = 'OOXXO'
const betMethodThree134 = 'OXOOX'
const betMethodThree135 = 'OXOXO'
const betMethodThree145 = 'OXXOO'
const betMethodThree234 = 'XOOOX'
const betMethodThree235 = 'XOOXO'
const betMethodThree245 = 'XOXOO'
const betMethodThree345 = 'XXOOO'
const betMethodsThree = [
  betMethodThree123, betMethodThree124, betMethodThree134, betMethodThree234, betMethodThree125,
  betMethodThree135, betMethodThree145, betMethodThree235, betMethodThree245, betMethodThree345
]
const betMethodsThreeInChinese = {
  '万千百': betMethodThree123,
  '万千十': betMethodThree124,
  '万千个': betMethodThree125,
  '万百十': betMethodThree134,
  '万百个': betMethodThree135,
  '万十个': betMethodThree145,
  '千百十': betMethodThree234,
  '千百个': betMethodThree235,
  '千十个': betMethodThree245,
  '百十个': betMethodThree345,
  '123位': betMethodThree123,
  '124位': betMethodThree124,
  '125位': betMethodThree125,
  '134位': betMethodThree134,
  '135位': betMethodThree135,
  '145位': betMethodThree145,
  '234位': betMethodThree234,
  '235位': betMethodThree235,
  '245位': betMethodThree245,
  '345位': betMethodThree345,
  '前三': betMethodThree123,
  '中三': betMethodThree234,
  '后三': betMethodThree345,
}
export const betMethodsThreeToCommand = {
  [betMethodThree123]: '万千百',
  [betMethodThree124]: '万千十',
  [betMethodThree125]: '万千个',
  [betMethodThree134]: '万百十',
  [betMethodThree135]: '万百个',
  [betMethodThree145]: '万十个',
  [betMethodThree234]: '千百十',
  [betMethodThree235]: '千百个',
  [betMethodThree245]: '千十个',
  [betMethodThree345]: '百十个',
}

const betMethodFour1234 = 'OOOOX'
const betMethodFour1345 = 'OXOOO'
const betMethodFour1245 = 'OOXOO'
const betMethodFour1235 = 'OOOXO'
const betMethodFour2345 = 'XOOOO'
const betMethodsFour = [
  betMethodFour1234, betMethodFour1345, betMethodFour1245, betMethodFour1235, betMethodFour2345
]
const betMethodsFourInChinese = {
  '万千百十': betMethodFour1234,
  '万百十个': betMethodFour1345,
  '万千十个': betMethodFour1245,
  '万千百个': betMethodFour1235,
  '千百十个': betMethodFour2345,
  '1234位': betMethodFour1234,
  '1345位': betMethodFour1345,
  '1245位': betMethodFour1245,
  '1235位': betMethodFour1235,
  '2345位': betMethodFour2345,
  '前四': betMethodFour1234,
  '后四': betMethodFour2345,
}
export const betMethodsFourToCommand = {
  [betMethodFour1234]: '万千百十',
  [betMethodFour1345]: '万百十个',
  [betMethodFour1245]: '万千十个',
  [betMethodFour1235]: '万千百个',
  [betMethodFour2345]: '千百十个',
}

export const betMethods = {
  [betMethodOne1]: '一字定位 OXXXX',
  [betMethodOne2]: '一字定位 XOXXX',
  [betMethodOne3]: '一字定位 XXOXX',
  [betMethodOne4]: '一字定位 XXXOX',
  [betMethodOne5]: '一字定位 XXXXO',

  [betMethodTwo12]: '二字定位 OOXXX',
  [betMethodTwo13]: '二字定位 OXOXX',
  [betMethodTwo14]: '二字定位 OXXOX',
  [betMethodTwo15]: '二字定位 OXXXO',
  [betMethodTwo23]: '二字定位 XOOXX',
  [betMethodTwo24]: '二字定位 XOXOX',
  [betMethodTwo25]: '二字定位 XOXXO',
  [betMethodTwo34]: '二字定位 XXOOX',
  [betMethodTwo35]: '二字定位 XXOXO',
  [betMethodTwo45]: '二字定位 XXXOO',

  [betMethodThree123]: '三字定位 OOOXX',
  [betMethodThree124]: '三字定位 OOXOX',
  [betMethodThree134]: '三字定位 OXOOX',
  [betMethodThree234]: '三字定位 XOOOX',
  [betMethodThree125]: '三字定位 OOXXO',
  [betMethodThree135]: '三字定位 OXOXO',
  [betMethodThree145]: '三字定位 OXXOO',
  [betMethodThree235]: '三字定位 XOOXO',
  [betMethodThree245]: '三字定位 XOXOO',
  [betMethodThree345]: '三字定位 XXOOO',

  [betMethodFour1234]: '四字定位 OOOOX',
  [betMethodFour1345]: '四字定位 OXOOO',
  [betMethodFour1245]: '四字定位 OOXOO',
  [betMethodFour1235]: '四字定位 OOOXO',
  [betMethodFour2345]: '四字定位 XOOOO',
}

export const defaultMethods = {
  one: betMethodOne1,
  two: betMethodTwo12,
  three: betMethodThree123,
  four: betMethodFour1234
}

// 默認打法 OXXOX
export const defaultBetMethod = 'OXXOX'

export const defaultRobotPlayOne = `万1234=3
万23456=2
万36789=5
万234567=3
万12345678=10
万1234789=2
万012349=3
万045789=8
万0123567=20
万012789=15
万1234589=5
万0578=5
万1389=2
万124568=8

千1234=3
千23456=2
千36789=5
千234567=3
千12345678=10
千1234789=2
千012349=3
千045789=8
千0123567=20
千012789=15
千1234589=5
千0578=5
千1389=2
千124568=8

百1234=3
百23456=2
百36789=5
百234567=3
百12345678=10
百1234789=2
百012349=3
百045789=8
百0123567=20
百012789=15
百1234589=5
百0578=5
百1389=2
百124568=8

十0368=15
十01368=20
十023689=30
十0123689=5
十123689=5
十1236789=8
十236789=5
十2346789=20
十23456789=30
十3456789=30
十456789=30
十4589=10
十45689=10
十5689=10

个0368=50
个01368=40
个023689=30
个0123689=20
个123689=30
个1236789=30
个236789=40
个2346789=50
个23456789=50
个3456789=20
个456789=30
个4589=8
个45689=15
个5689=12`
export const defaultRobotPlayTwo = `万千1234-1234=3
万千23456-23456=2
万千36789-1234=2
万千234567-234567=5
万千12345678-12345678=10
万千1234789-23467=5
万千012349-012349=3

万百045789-045789=5
万百0123567-045789=5
万百012789-012789=5
万百1234589-1234589=3
万百0578-02578=4
万百1389-13567=4
万百124568-1234567=10

万十1234-4567=3
万十23456-23456=5
万十36789-34567=5
万十234567-234567=3
万十12345678-12345678=10
万十1234789-1234789=6
万十012349-0124=3

万个1234-1234=3
万个123456-2345678=2
万个136789-136789=5
万个1234567-1234567=3
万个2345678-2345678=5

千百045789-045789=5
千百0123567-0123567=10
千百012789-12456=15
千百1234589-1234589=5

千十0578-01234=5
千十012578-012346=10
千十2345678-2345678=4

千个0678-1234=5
千个0123478-0123456=10
千个2345678-2345678=4

百十1234-23456=2
百十23456-23456=2
百十36789-36789=3
百十234567-23456=3
百十12345678-12345678=10

百个1234789-012349=5
百个012349-012349=3
百个045789-13567=2

十个0368-1234=3
十个01368-01368=5
十个0239-0123=5
十个123689-23456789=30

万千1234-1234=3
万千23456-23456=2
万千36789-1234=2
万千234567-234567=5
万千12345678-12345678=10
万千1234789-23467=5
万千012349-012349=3

万百045789-045789=5
万百0123567-045789=5
万百012789-012789=5
万百1234589-1234589=3
万百0578-02578=4
万百1389-13567=4
万百124568-1234567=10

万十1234-4567=3
万十23456-23456=5
万十36789-34567=5
万十234567-234567=3
万十12345678-12345678=10
万十1234789-1234789=6
万十012349-0124=3

万个1234-1234=3
万个123456-2345678=2
万个136789-136789=5
万个1234567-1234567=3
万个2345678-2345678=5

千百045789-045789=5
千百0123567-0123567=10
千百012789-12456=15
千百1234589-1234589=5

千十0578-01234=5
千十012578-012346=10
千十2345678-2345678=4

千个0678-1234=5
千个0123478-0123456=10
千个2345678-2345678=4

百十1234-23456=2
百十23456-23456=2
百十36789-36789=3
百十234567-23456=3
百十12345678-12345678=10

百个1234789-012349=5
百个012349-012349=3
百个045789-13567=2

十个0368-1234=3
十个01368-01368=5
十个0239-0123=5
十个123689-23456789=30

万千12345678-12345678去重=15
万千2345678-2345678去重=20
万千23456789-23456789去重=20
万千3456789-3456789去重=15
万千123456789-123456789去重=30
万千0136789-345678去重=8
万千0345678-1345678去重=10
万千02345689-456789去重=3

万百12345678-12345678去重=4
万百2345678-2345678去重=5
万百23456789-23456789去重=7
万百3456789-3456789去重=8

万十12345678-12345678去重=5
万十2345678-2345678去重=3
万十23456789-23456789去重=1
万十3456789-3456789去重=1

万个12345678-12345678去重=5
万个2345678-2345678去重=4
万个23456789-23456789去重=2
万个3456789-3456789去重=3

百个1234789-0123489去重=10
百个0123489-0123489去重=3
百个045789-1234567去重=2

十个1234-1234去重=3
十个123478-123478去重=5
十个013678-013678去重=8
十个0123459-0123459去重=10
十个1236789-2345678去重=30
十个1236789-1234789去重=20
十个234678-234678去重=15`
export const defaultRobotPlayThree = `万千百1234-1234-12345=0.1
万千百23456-23456-23456=0.2
万千百456789-456789-456789=0.3

万千十234567-234567-234567=0.1
万千十1234567-1234567-1234567=0.2

万千个12345678-2345678-2345678=1
万千个2345678-2345678-2345678=3

千百十12349-012349-012349=0.2
千百十045789-045789-123456=0.3
千百十0123567-045789-045789=3

千百个12349-12345678-012349=0.7
千百个0123479-345678-0123467=0.5
千百个1234789-345678-01234678=0.3

百十个3456789-3456789-3456789=1
百十个345678-345678-345678=2
百十个12345678-12345678-12345678=0.3`
export const defaultRobotPlayFour = `万千百十1234-1234-12345-12345678=0.1
万千百十23456-23456-23456-23456=0.2
万千百十456789-456789-456789-456789=0.3
万千百十3456789-3456789-3456789-3456789=0.5
万千百十2345678-2345678-2345678-2345678=0.3

万千百个234567-234567-234567-234567=0.1
万千百个1234567-1234567-1234567-234567=0.2
万千百个234567-234567-234567-234567=0.3
万千百个0234567-01234567-01234567-34567=0.5
万千百个34567-234567-34567-234567=0.2

万千十个234567-234567-234567-234567=0.1
万千十个234567-234567-1234567-234567=0.2
万千十个34567-24567-23456-23456=0.3
万千十个0234567-01234567-01234567-34567=0.5
万千十个3456789-23456789-345678-2345678=0.2

万百十个234567-234567-234567-234567=0.1
万百十个1234567-1234567-1234567-234567=0.2
万百十个234567-234567-234567-234567=0.3
万百十个0234567-01234567-01234567-34567=0.5
万百十个34567-234567-34567-234567=0.2

千百十个0134567-1234567-1234567-1234567=0.2
千百十个234567-234567-234567-234567=0.2
千百十个2345678-2345678-2345678-2345678=0.3
千百十个234567-01234567-01234567-34567=0.5
千百十个345678-2345678-345678-234567=0.2`

export const defaultRobotPlayFan = `1番100
1番200
1番400
1番650
1番800
1番900
1番1000

2番30
2番60
2番77
2番88
2番99
2番122
2番133

3番50
3番80
3番120
3番150
3番180
3番233
3番250
3番290
3番400
3番500

4番20
4番30
4番40
4番50
4番60
4番185
4番195
4番200
4番250`
export const defaultRobotPlayZheng = `1正100
1正200
1正220
1正250
1正300
1正330
1正350

2正30
2正60
2正70
2正80
2正90
2正120
2正130

3正50
3正80
3正122
3正155
3正188
3正233
3正266
3正290
3正350
3正500

4正20
4正25
4正35
4正45
4正55
4正85
4正95
4正155
4正255`
export const defaultRobotPlayNian = `1念2=30
1念2=50
1念2=100
1念2=200

1念3=30
1念3=50
1念3=100
1念3=200

1念4=30
1念4=50
1念4=100
1念4=200

2念1=40
2念1=80
2念1=250
2念1=300

2念3=40
2念3=80
2念3=250
2念3=300

2念4=40
2念4=80
2念4=250
2念4=300

3念1=50
3念1=80
3念1=300
3念1=500

3念2=50
3念2=80
3念2=300
3念2=500

3念4=50
3念4=80
3念4=300
3念4=500

4念1=30
4念1=40
4念1=50
4念1=100

4念2=30
4念2=40
4念2=50
4念2=100

4念3=30
4念3=40
4念3=50
4念3=100`
export const defaultRobotPlayJiao = `12角30
12角50
12角65
12角85
12角100
12角120
12角133
12角150
12角180
12角200
12角222
12角250
12角300
12角333
12角350
12角380
12角500
12角666
12角800
12角1000
12角2000

23角30
23角50
23角70
23角90
23角100
23角120
23角150
23角160
23角180
23角200
23角222
23角300
23角333
23角555
23角888
23角1111
23角1588

34角30
34角50
34角70
34角90
34角100
34角120
34角150
34角160
34角180
34角200
34角222
34角300

14角170
14角270
14角370
14角450
14角550
14角700
14角800
14角900
14角1000
14角1100
14角1200`
export const defaultRobotPlayDan = `单60
单70
单88
单111
单120
单150
单200
单300
单500
单1000`
export const defaultRobotPlayShuang = `双50
双77
双90
双130
双140
双220
双250
双333
双444
双460
双550
双630
双1500`
export const defaultRobotPlayDa = `大111
大222
大333
大400
大470
大510
大630
大970
大1111`
export const defaultRobotPlayXiao = `小40
小50
小60
小70
小80
小120
小230
小260
小340
小440
小540
小666
小1666`
export const defaultRobotPlayTong = ``
export const defaultRobotPlayZhong = `123中70
123中100
123中120
123中150
123中170
123中270
123中300
123中500
123中600
123中700
123中777
123中888
123中1000
123中1500
123中2000

234中100
234中150
234中200
234中250
234中280
234中330
234中444
234中555
234中666
234中777
234中800
234中900

134中50
134中80
134中110
134中130
134中160
134中190
134中230
134中280
134中330
134中400
134中500

124中100
124中200
124中222
124中333
124中444
124中500
124中666
124中760`
export const defaultRobotPlayJia = ``

const reCommonChatCommand = /^((查|退单)|([上下]\d+))$/

export function isCommonChatCommand(input) {
  return reCommonChatCommand.test(input)
}

export function isFixedBetCommand(input, options = { onlyFan: false }) {
  if (options.onlyFan && /(12|14|23|34)([=\/]?)\d+(\.\d+)?/.test(input)) {
    return false
  }
  const r = parse(input, defaultBetMethod)
  return !r.error
}

export function parseCommand(input, { defaultMethod }) {
  const r = parse(input, defaultMethod ?? defaultBetMethod)
  if (r.error) {
    throw new Error(r.error)
  }
  const o = output(r)
  return { method: r.method, numbers: o, amount: r.amount }
}

export const reValidFanChatCommand = /^(([单双大小]\d+(\.\d+)?)|([1234]番[=\/]?\d+(\.\d+)?)|([1234][正\+][=\/]?\d+(\.\d+)?)|([1234][念+][1234][=\/]\d+(\.\d+)?)|((12|14|23|34)(角[=\/]?)\d+(\.\d+)?)|([1234]通[1234]{2}[=\/]\d+(\.\d+)?)|([1234]车[=\/]?\d+(\.\d+)?)|((124|123|234|134)中[=\/]?\d+(\.\d+)?)|([1234][加+][1234]{2}[=\/]\d+(\.\d+)?))$/

export function isFanBetCommand(input, options = { only: false }) {
  return reValidFanChatCommand.test(input) || (options.only && /(12|14|23|34)([=\/]?)\d+(\.\d+)?/.test(input))
}

export function parseFanCommand(input, options = { only: false }) {
  {
    const r = input.match(/^([单双大小])(\d+(\.\d+)?)$/)
    if (r) {
      return { method: 'FAN', bet: r[1], amount: parseFloat(r[2]) }
    }
  }
  {
    const r = input.match(/^([1234]番)[=\/]?(\d+(\.\d+)?)$/)
    if (r) {
      return { method: 'FAN', bet: r[1], amount: parseFloat(r[2]) }
    }
  }
  {
    const r = input.match(/^([1234])(正|\+)[=\/]?(\d+(\.\d+)?)$/)
    if (r) {
      return { method: 'FAN', bet: `${r[1]}正`, amount: parseFloat(r[3]) }
    }
  }
  {
    const r = input.match(/^([1234])(念|\+)([1234])[=\/](\d+(\.\d+)?)$/)
    if (r && r[1] !== r[3]) {
      return { method: 'FAN', bet: `${r[1]}念${r[3]}`, amount: parseFloat(r[4]) }
    }
  }
  {
    const r = input.match(/^(12|14|23|34)(角[=\/]?)(\d+(\.\d+)?)$/)
    if (r) {
      return { method: 'FAN', bet: `${r[1]}角`, amount: parseFloat(r[3]) }
    }
  }
  if (options.only) {
    const r = input.match(/^(12|14|23|34)([=\/]?)(\d+(\.\d+)?)$/)
    if (r) {
      return { method: 'FAN', bet: `${r[1]}角`, amount: parseFloat(r[3]) }
    }
  }
  {
    const r = input.match(/^([1234])通([1234]{2})[=\/](\d+(\.\d+)?)$/)
    if (r && !r[2].includes(r[1]) && r[2][0] < r[2][1]) {
      return { method: 'FAN', bet: `${r[2]}${fanTong[r[1]]}通`, amount: parseFloat(r[3]) }
    }
  }
  {
    const r = input.match(/^([1234])车[=\/]?(\d+(\.\d+)?)$/)
    if (r) {
      return { method: 'FAN', bet: `${fanChe[r[1]]}中`, amount: parseFloat(r[2]) }
    }
  }
  {
    const r = input.match(/^(124|123|234|134)中[=\/]?(\d+(\.\d+)?)$/)
    if (r) {
      return { method: 'FAN', bet: `${r[1]}中`, amount: parseFloat(r[2]) }
    }
  }
  {
    const r = input.match(/^([1234])(加|\+)([1234]{2})[=\/](\d+(\.\d+)?)$/)
    if (r && !r[3].includes(r[1]) && r[3][0] !== r[3][1] && r[3][0] < r[3][1]) {
      return { method: 'FAN', bet: `${r[1]}加${r[3]}`, amount: parseFloat(r[4]) }
    }
  }
  return false
}

export function calcFanNumber(game, draw) {
  return parseInt(draw.slice(3).join('')) % 4 || 4
}
